import { Plugin } from 'prosemirror-state';

import { EditorOptions } from '@lyearn/lygo-core';

import ToggleListItemNodeView from './NodeView';

function plugins({ createReactNodeView, t }: EditorOptions) {
  return [
    new Plugin({
      props: {
        nodeViews: {
          toggle_list_item(node, view, getPos, decorations) {
            return createReactNodeView({
              node,
              view,
              getPos,
              decorations,
              component: ToggleListItemNodeView,
            });
          },
        },
      },
    }),
  ];
}

export default plugins;
